export const PayrollSectionData = {
    countries: [
      {
        country: "India",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "The payroll cycle in India is typically monthly. It is commonly based on the 30th or last day of the month, but other variations like weekly or bi-weekly payroll are also used depending on the company’s policy.",
          },
          th_salary: {
            description: "The 13th-month salary is not mandatory in India, but many companies offer it as an additional benefit, typically paid during the festival season or at the end of the year.",
          },
        },
      },
      {
        country: "South Africa",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In South Africa, there is no set payroll cycle. The payroll cycle is typically stipulated in the employment contract, which is to be agreed upon by the employee and employer.",
            types: ["Monthly", "Weekly", "Bi-weekly"],
          },
          th_salary: {
            description: "13th-month salary payments are customary in South Africa and should be paid in December of each year.",
          },
        },
      },
      {
        country: "USA",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In the USA, payroll is most commonly paid on a bi-weekly or semi-monthly cycle, though monthly and weekly payroll are also common depending on the industry and company policy.",
          },
          th_salary: {
            description: "The 13th-month salary is not mandatory in the USA, though some companies provide year-end bonuses, which can function similarly to the 13th-month salary.",
          },
        },
      },
      {
        country: "Germany",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In Germany, the payroll cycle is typically monthly, with salaries paid at the end of the month or the beginning of the next month.",
          },
          th_salary: {
            description: "The 13th-month salary is a common practice in Germany and is often paid in December as a bonus.",
          },
        },
      },
      {
        country: "Brazil",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In Brazil, the payroll cycle is typically monthly, and employees are paid at the end of each month.",
          },
          th_salary: {
            description: "The 13th-month salary is mandatory in Brazil, with payment made in two installments: one in November and the second in December.",
          },
        },
      },
      {
        country: "Mexico",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In Mexico, payroll is generally paid bi-weekly, although monthly payroll is also common, depending on the employer.",
          },
          th_salary: {
            description: "The 13th-month salary is mandatory in Mexico and is paid in two installments: one in June and the other in December.",
          },
        },
      },
      {
        country: "Argentina",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In Argentina, payroll is usually paid monthly, though there are exceptions depending on company agreements.",
          },
          th_salary: {
            description: "The 13th-month salary is mandatory in Argentina and is typically paid in December.",
          },
        },
      },
      {
        country: "France",
        section: "Payroll",
        details: {
          payroll_cycle: {
            description: "In France, the payroll cycle is typically monthly, with employees being paid at the end of each month.",
          },
          th_salary: {
            description: "The 13th-month salary is a common practice in France but not legally mandatory. It is usually paid at the end of the year.",
          },
        },
      },
    ],
  };
  